exports = module.exports = require("../../../../../table-showoff/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Snackbar__Snackbar__1sByj {\n  visibility: hidden;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 3px;\n  padding: 16px;\n  position: fixed;\n  z-index: 999999;\n  top: 30px;\n  font-size: 1.0rem;\n}\n\n.Snackbar__Show__afdTV {\n  visibility: visible;\n  -webkit-animation: Snackbar__fadein__3L6kn 0.5s, Snackbar__fadeout__3T9W3 0.5s 4.5s;\n  animation: Snackbar__fadein__3L6kn 0.5s, Snackbar__fadeout__3T9W3 0.5s 4.5s;\n}\n\n/* .Snackbar:hover {\n  visibility: visible;\n  -webkit-animation-play-state: paused;\n  animation-play-state: paused;\n} */\n\n\n@-webkit-keyframes Snackbar__fadein__3L6kn {\n  from {top: 0; opacity: 0;} \n  to {top: 30px; opacity: 1;}\n}\n\n@keyframes Snackbar__fadein__3L6kn {\n  from {top: 0; opacity: 0;}\n  to {top: 30px; opacity: 1;}\n}\n\n@-webkit-keyframes Snackbar__fadeout__3T9W3 {\n  from {top: 30px; opacity: 1;} \n  to {top: 0; opacity: 0;}\n}\n\n@keyframes Snackbar__fadeout__3T9W3 {\n  from {top: 30px; opacity: 1;}\n  to {top: 0; opacity: 0;}\n}", ""]);

// exports
exports.locals = {
	"Snackbar": "Snackbar__Snackbar__1sByj",
	"Show": "Snackbar__Show__afdTV",
	"fadein": "Snackbar__fadein__3L6kn",
	"fadeout": "Snackbar__fadeout__3T9W3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/components/UI/Snackbar/Snackbar.css
// module id = 476
// module chunks = 0